import { html, nothing } from '@shared/utils/rendering/html';
import ProgressCard from '../../../shared/data-displays/progress-card';
import { useEffect, useState } from 'preact/hooks';
import { useFeatureChecks } from '@core/utils/features/feature-context';

const DashboardRatings = ({ entityAssessment }) => {
    const { useFeature } = useFeatureChecks();
    const showRdarrRating = useFeature('dashboard.rdarrRating.visible', false);
    const [progress, setProgress] = useState(null);

    useEffect(() => {
        setProgress({
            complianceRating: entityAssessment?.overallCompliance ?? 0.0,
            rating: entityAssessment?.overallRating ?? 0.0,
        });
    }, [entityAssessment?.overallRating, entityAssessment?.overallCompliance]);

    return progress
        ? html`
              <div class="flex-wrap-4">
                  <${ProgressCard}
                      title=${{ text: 'Percentage Completed' }}
                      progress=${{
                          value: progress.complianceRating,
                          decimalPlaces: 1,
                          unit: '%',
                      }}
                      css="flex-item"
                  />

                  ${
                      showRdarrRating
                          ? html`
                                <${ProgressCard}
                                    title=${{ text: 'RDARR Rating' }}
                                    progress=${{
                                        value: progress.rating,
                                        decimalPlaces: 2,
                                        unit: '',
                                    }}
                                    css="flex-item"
                                />
                            `
                          : nothing
                  }
              </div>
          `
        : nothing;
};

export default DashboardRatings;
